import { Component, OnInit } from '@angular/core';
// import { Stripe } from '@ionic-native/stripe/ngx';
import { AlertService } from '../services/alert/alert.service';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '../services/api/api.service';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { EncryptDecryptService } from '../services/utils/encrypt-decrypt.service'
import { Platform } from '@ionic/angular';
declare var Stripe;
var CryptoJS = require("crypto-js");

@Component({
  selector: 'app-card-payment',
  templateUrl: './card-payment.page.html',
  styleUrls: ['./card-payment.page.scss'],
})
export class CardPaymentPage implements OnInit {
  stripe: any;
  card: any;
  cardNumber: string;
  cardMonth: number;
  cardYear: number;
  cardCVV: string;

  countryName: string = environment.countryName;
  zipCode: number;

  isVisaCard: boolean = true;
  isMasterCard: boolean = true;
  isAmericanExpressCard: boolean = true;

  errorMessage:any = ''

  minDate: string = new Date().toISOString();
  maxData : any = (new Date()).getFullYear() + 20;

  cartData:any = ''
  selectedAddress:any = ''
  payementTypeId:any = ''
  deliveryCharge:any = 0
  gatewayKeys:any = ''
  secretKey:string = environment.secretKey;
  isWeb:any = false
  constructor(public platform: Platform,private encryptdecrypt: EncryptDecryptService,public api: ApiService,public alert: AlertService,private route: ActivatedRoute,private router: Router) {
      this.cartData = JSON.parse(localStorage.getItem("priceDetails"))
      this.selectedAddress = JSON.parse(localStorage.getItem("selectedAddress"))
      this.deliveryCharge = JSON.parse(localStorage.getItem("delivery-charge") || '0')
      if(this.deliveryCharge == ''|| this.deliveryCharge == undefined || this.deliveryCharge == null){
        this.deliveryCharge = 0
      }
   }

  ngOnInit() {
    let storeId:any = JSON.parse(localStorage.getItem('cart-store-id'))

    this.getPaymentTypes()

    this.platform.ready().then(async () => {
        if (this.platform.is('hybrid')) {
          this.isWeb = false
          this.api.getPaymentKeys(storeId).subscribe(async(result:any) => {
            if(result.status == true){
              console.log(result)
              this.gatewayKeys = result.data;
              let stripePublishKey: any = this.encryptdecrypt.decrypt(result.data.public_key,this.secretKey)
              console.log(stripePublishKey)
              this.stripe.setPublishableKey(stripePublishKey);
              this.countryName = result.data.country;
      
            }
          })
        }
        else{
          this.isWeb = true
          this.api.getPaymentKeys(storeId).subscribe(async(result:any) => {
            if(result.status == true){
              console.log(result)
              this.gatewayKeys = result.data;
              let stripePublishKey: any = this.encryptdecrypt.decrypt(result.data.public_key,this.secretKey)
              console.log(stripePublishKey)
              this.stripe = Stripe(stripePublishKey);
              this.countryName = result.data.country;
              this.setupStripe()
            }
          })
        }
      })
  }

  setupStripe() {
    let elements = this.stripe.elements();
    var style = {
      base: {
        color: '#32325d',
        lineHeight: '24px',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
          color: '#aab7c4'
        }
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a'
      }
    };

    this.card = elements.create('card', { style: style });
    console.log(this.card);
    this.card.mount('#card-element');

    this.card.addEventListener('change', event => {
      var displayError = document.getElementById('card-errors');
      if (event.error) {
        displayError.textContent = event.error.message;
      } else {
        displayError.textContent = '';
      }
    });

    var form = document.getElementById('payment-form');
    form.addEventListener('submit', event => {
      event.preventDefault();
      console.log(event)

      this.stripe.createSource(this.card).then(result => {
        if (result.error) {
          var errorElement = document.getElementById('card-errors');
          errorElement.textContent = result.error.message;
        } else {
          console.log(result);
          this.doPayment(result.id);
        }
      });
    });
  }

  validateCard(){

     if(this.cardNumber == undefined || this.cardNumber == null || this.cardNumber == ''){
        this.errorMessage = 'Please enter the card number'
        return
      }

      let temp:any = this.cardNumber.replace(/\s/g, '')

     if(temp.length < 16){
        this.errorMessage = 'Invalid card number'
        return
      }
      else if(this.checkCardNumberisValid(this.cardNumber) == false) {
        this.errorMessage = 'Invalid card number'
        return
      }

    if(this.cardMonth == undefined || this.cardMonth == null){
        this.errorMessage = 'Please enter the expiration date'
        return
      }
    
    let expirationDate:any = this.getMonthAndYear(this.cardMonth)

    let cardExpiryMonth = expirationDate.month;
    this.cardYear = expirationDate.year;

    if(this.cardCVV == undefined || this.cardCVV == null || this.cardCVV == ''){
        this.errorMessage = 'Please enter the CVV number'
        return
      } 

    if(this.zipCode == undefined || this.zipCode == null || this.zipCode.toString().length < 5){
      this.errorMessage = 'Please enter the zipcode'
      return
    } 

    let card = {
      number: this.cardNumber.replace(/\s/g, ''),
      expMonth: cardExpiryMonth,
      expYear: this.cardYear,
      cvc: this.cardCVV
     };

     console.log(card)

     // Run card validation here and then attempt to tokenise
     
     this.stripe.createCardToken(card)
        .then((token:any)=> {
          console.log(token)
          this.doPayment(token.id)
        })
        .catch(error => alert(JSON.stringify(error)));
  }

  getPaymentTypes(){
    this.api.getPaymentTypes().subscribe((result:any) => {
        if(result.status == true){
          if(result.data.length > 0) {
            for(let i = 0;i< result.data.length; i++){
              if(result.data[i].payment_type == 'card'){
                this.payementTypeId = result.data[i].id
              }
            }
          }
        }
      },(err)=>{
        console.log(err)
      });
  }

  doPayment(token:any){

    let reqData:any = {
      "device_token": localStorage.getItem("uuid"),
      "order": JSON.parse(localStorage.getItem("order_id")),
      "delivery_address": this.selectedAddress,
      "grant_total": JSON.parse(this.cartData.grand_total),
      "sub_total": JSON.parse(this.cartData.sub_total),
      "discount": JSON.parse(this.cartData.discount),
      "discount_percent": JSON.parse(this.cartData.discount_percent),
      "discount_percentage": this.cartData.discount_percentage,
      "payment_type": this.payementTypeId,
      "driver_tips": JSON.parse(this.cartData.tip),
      "delivery_charge": JSON.parse(localStorage.getItem('delivery-charge') || '0'),
      "order_comments": this.cartData.comments
    }
    this.api.placeOrder(reqData).subscribe((result:any) => {
      if(result.status == true){
        let requestData:any = {
          "delivery_address_id": this.selectedAddress,
          "amount": JSON.parse(this.cartData.grand_total),
          "source": this.gatewayKeys.country,
          "order": JSON.parse(localStorage.getItem("order_id")),
          "payment_token": token,
          "driver_tips": JSON.parse(this.cartData.tip),
          "store_id": JSON.parse(localStorage.getItem('cart-store-id')),
          "country": this.gatewayKeys.country,
          "gateway_type": this.gatewayKeys.gateway_type,
          "currency": this.gatewayKeys.currency,
        }
        let orderId:any = 'Order Id : #'+result.data.id
        this.api.makePayment(requestData).subscribe((result:any) => {
          if(result.status == true){
            this.alert.presentAlert('Payment Successful',orderId,"We'll let you know when your items are on the way.")
            let id = localStorage.getItem('store_id')
            this.router.navigate(['/home/'+id])
          }
          else{
            this.alert.presentAlert('Payment Failed','',result.message)
          }
        },(err)=>{
          console.log(err)
          this.alert.presentAlert('Payment Failed','',"Please try again later")
          let id = localStorage.getItem('store_id')
          this.router.navigate(['/home/'+id])
        });
      }
    },(err)=>{
      console.log(err)
    });

  }

  setCardType(){

    //first remove previous spaces
    let tempCardNumner: any = this.cardNumber.replace(/\s/g, '');

    let cardNameDetected: any = this.GetCardType(tempCardNumner) 
    if(cardNameDetected == 'Visa'){
      this.isVisaCard = true;
      this.isMasterCard = false;
      this.isAmericanExpressCard = false;
    }
    else if(cardNameDetected == 'Mastercard'){
      this.isVisaCard = false;
      this.isMasterCard = true;
      this.isAmericanExpressCard = false;
    }
    else if(cardNameDetected == 'AMEX'){
      this.isVisaCard = false;
      this.isMasterCard = false;
      this.isAmericanExpressCard = true;
    }
    else {
      this.isVisaCard = false;
      this.isMasterCard = false;
      this.isAmericanExpressCard = false;
    }
    
  }

  cc_format(value: string) {
    this.setCardType()
    const v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
    const matches = v.match(/\d{4,16}/g);
    const match = (matches && matches[0]) || '';
    const parts = [];
    for (let i = 0, len = match.length; i < len; i += 4) {
      parts.push(match.substring(i, i + 4));
    }
    if (parts.length > 0) {
      this.cardNumber = parts.join(' ');
    } else {
      this.cardNumber = value;
    }
  }

GetCardType(number:any)
  {
      // visa
      var re = new RegExp("^4");
      if (number.match(re) != null)
          return "Visa";

      // Mastercard 
      // Updated for Mastercard 2017 BINs expansion
      if (/^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/.test(number)) 
          return "Mastercard";

      // AMEX
      re = new RegExp("^3[47]");
      if (number.match(re) != null)
          return "AMEX";

      // Discover
      re = new RegExp("^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)");
      if (number.match(re) != null)
          return "Discover";

      // Diners
      re = new RegExp("^36");
      if (number.match(re) != null)
          return "Diners";

      // Diners - Carte Blanche
      re = new RegExp("^30[0-5]");
      if (number.match(re) != null)
          return "Diners - Carte Blanche";

      // JCB
      re = new RegExp("^35(2[89]|[3-8][0-9])");
      if (number.match(re) != null)
          return "JCB";

      // Visa Electron
      re = new RegExp("^(4026|417500|4508|4844|491(3|7))");
      if (number.match(re) != null)
          return "Visa Electron";

      return "";
  }


  getMonthAndYear(value:any){
    let dateObj: any = new Date(value);
    let year: any = dateObj.getFullYear().toString().substr(-2)
    let month: any = dateObj.getMonth() + 1
    return { "year" : year,"month" : month }
  }


  checkCardNumberisValid(cardNo: any){

    // Remove all whitespaces from card number.
    cardNo = cardNo.replace(/\s/g,'');

    if(!cardNo.length){
      return;
    }
  
    // 1. Remove last digit;
    const lastDigit = Number(cardNo[cardNo.length - 1]);
  
    // 2. Reverse card number
    const reverseCardNumber = cardNo
      .slice(0,cardNo.length - 1)
      .split('')
      .reverse()
      .map(x => Number(x));
    
    let sum = 0;
  
    // 3. + 4. Multiply by 2 every digit on odd position.
    // Subtract 9 if digit > 9
    for(let i = 0; i <= reverseCardNumber.length -1; i += 2){
      reverseCardNumber[i] = reverseCardNumber[i]*2;
      if(reverseCardNumber[i] > 9){
        reverseCardNumber[i] = reverseCardNumber[i] - 9;
      }
    }
  
    // 5. Make the sum of obtained values from step 4.
    sum = reverseCardNumber
      .reduce((acc, currValue) => (acc + currValue), 0);
  
    // 6. Calculate modulo 10 of the sum from step 5 and the last digit. 
    // If it's 0, you have a valid card number :)
    return ((sum + lastDigit) % 10 === 0);
  }

}
